import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <div className="logo-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span className="logo-text">CertiTrust</span>
        </div>

        {/* Navigation */}
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className="nav-link">Home</Link>
          <div className="nav-dropdown">
            <span className="nav-link dropdown-trigger">
              Features
              <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <div className="dropdown-menu">
              <Link to="/upload" className="dropdown-item">Upload Certificates</Link>
              <Link to="/check" className="dropdown-item">Verify Certificates</Link>
              <Link to="/admin" className="dropdown-item">Analytics</Link>
            </div>
          </div>
          <div className="nav-dropdown">
            <span className="nav-link dropdown-trigger">
              Resources
              <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <div className="dropdown-menu">
              <Link to="/database" className="dropdown-item">Database Admin</Link>
              <a href="#" className="dropdown-item">Documentation</a>
              <a href="#" className="dropdown-item">API Guide</a>
            </div>
          </div>
          <Link to="/admin" className="nav-link">Analytics</Link>
        </nav>

        {/* Action Buttons */}
        <div className="header-actions">
          <Link to="/check" className="btn-login">Verify</Link>
          <Link to="/upload" className="btn-primary">Upload Certificate</Link>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
    </header>
  );
};

export default Header;
